import React, { useState } from 'react';
import { Contractor } from '../../services/contractorService';
import { useNotification } from '../layouts/Layout';
import AddOrderForm from '../projects/AddOrderForm';

interface AddOrderDialogProps {
  open: boolean;
  onClose: () => void;
  contractor: Contractor | null;
  onSuccess: () => void;
}

const AddOrderDialog: React.FC<AddOrderDialogProps> = ({
  open,
  onClose,
  contractor,
  onSuccess
}) => {
  const { showNotification } = useNotification();

  // Funkcja obsługująca dodanie zamówienia
  const handleAdd = (newOrder: any) => {
    showNotification('Zamówienie zostało dodane pomyślnie', 'success');
    onSuccess();
  };

  // Funkcje, które nie będą używane, ale są wymagane przez interfejs
  const handleEdit = (editedOrder: any) => {};
  const handleDelete = (orderId: number) => {}; // Zmieniono typ orderId na number

  // Przygotowanie danych początkowych dla formularza
  const getContractorEmails = (contractor: Contractor) => {
    // Sprawdź, czy email jest "brak" lub "brak email"
    const isMainEmailEmpty = contractor.email === 'brak' || 
                            contractor.email === 'brak email' || 
                            contractor.email === 'Brak email' || 
                            contractor.email === 'Brak';
    
    // Sprawdź, czy email2 istnieje i nie jest pusty
    const hasSecondaryEmail = contractor.email2 && contractor.email2.trim() !== '';
    
    if (isMainEmailEmpty) {
      // Przypadek 3: email to "brak" lub "brak email", a email2 jest podany
      if (hasSecondaryEmail) {
        return contractor.email2;
      } 
      // Przypadek 2: email to "brak" lub "brak email", a email2 jest null
      return contractor.email;
    } else {
      // Przypadek 4: email jest normalny, a email2 jest podany
      if (hasSecondaryEmail) {
        return `${contractor.email}, ${contractor.email2}`;
      }
      // Przypadek 1: email jest normalny, a email2 jest null
      return contractor.email;
    }
  };

  const initialOrderData = contractor ? {
    contractor: getContractorEmails(contractor) || contractor.name || '',
    order_content: '',
    status: 'Przygotowano',
    delivery_date: null,
    contact_person_name: '',
    contact_person_surname: '',
    contact_person_phone: '',
    project_id: ''
  } : null;

  return (
    <AddOrderForm
      open={open}
      onClose={onClose}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      editMode={false}
      orderData={initialOrderData}
    />
  );
};

export default AddOrderDialog;
